/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import {
  POST_VERIFICATIONS_CREATE_CASEWORKER_TASK,
  POST_VERIFICATIONS_LINK_FILE,
  DELETE_VERIFICATIONS_FILE_LINKS_BY_LINK_ID,
  FETCH_VERIFICATIONS,
  GET_VERIFICATIONS_BY_VERIFICATION_ID,
  POST_VERIFICATIONS_SD_CREATE_CASEWORKER_TASK,
} from './actionTypes';

/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postVerificationsCreateCaseworkerTaskReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_VERIFICATIONS_CREATE_CASEWORKER_TASK);

/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostVerificationsCreateCaseworkerTaskReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_VERIFICATIONS_CREATE_CASEWORKER_TASK);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postVerificationsCreateCaseworkerTaskErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_VERIFICATIONS_CREATE_CASEWORKER_TASK);

/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postVerificationsLinkFileReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_VERIFICATIONS_LINK_FILE);

/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostVerificationsLinkFileReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_VERIFICATIONS_LINK_FILE);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postVerificationsLinkFileErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_VERIFICATIONS_LINK_FILE);

/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const deleteVerificationsFileLinksByLinkIdReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, DELETE_VERIFICATIONS_FILE_LINKS_BY_LINK_ID);

/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingDeleteVerificationsFileLinksByLinkIdReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, DELETE_VERIFICATIONS_FILE_LINKS_BY_LINK_ID);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const deleteVerificationsFileLinksByLinkIdErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, DELETE_VERIFICATIONS_FILE_LINKS_BY_LINK_ID);

/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchVerificationsReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_VERIFICATIONS);

/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchVerificationsReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_VERIFICATIONS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchVerificationsErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_VERIFICATIONS);

/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const getVerificationsByVerificationIdReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, GET_VERIFICATIONS_BY_VERIFICATION_ID);

/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingGetVerificationsByVerificationIdReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, GET_VERIFICATIONS_BY_VERIFICATION_ID);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const getVerificationsByVerificationIdErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, GET_VERIFICATIONS_BY_VERIFICATION_ID);

/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postVerificationsSdCreateCaseworkerTaskReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_VERIFICATIONS_SD_CREATE_CASEWORKER_TASK);

/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostVerificationsSdCreateCaseworkerTaskReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_VERIFICATIONS_SD_CREATE_CASEWORKER_TASK);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postVerificationsSdCreateCaseworkerTaskErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_VERIFICATIONS_SD_CREATE_CASEWORKER_TASK);

const reducers = combineReducers({
  postVerificationsCreateCaseworkerTask: postVerificationsCreateCaseworkerTaskReducer,

  isFetchingPostVerificationsCreateCaseworkerTask:
    isFetchingPostVerificationsCreateCaseworkerTaskReducer,
  postVerificationsCreateCaseworkerTaskError: postVerificationsCreateCaseworkerTaskErrorReducer,

  postVerificationsLinkFile: postVerificationsLinkFileReducer,

  isFetchingPostVerificationsLinkFile: isFetchingPostVerificationsLinkFileReducer,
  postVerificationsLinkFileError: postVerificationsLinkFileErrorReducer,

  deleteVerificationsFileLinksByLinkId: deleteVerificationsFileLinksByLinkIdReducer,

  isFetchingDeleteVerificationsFileLinksByLinkId:
    isFetchingDeleteVerificationsFileLinksByLinkIdReducer,
  deleteVerificationsFileLinksByLinkIdError: deleteVerificationsFileLinksByLinkIdErrorReducer,

  fetchVerifications: fetchVerificationsReducer,

  isFetchingFetchVerifications: isFetchingFetchVerificationsReducer,
  fetchVerificationsError: fetchVerificationsErrorReducer,

  getVerificationsByVerificationId: getVerificationsByVerificationIdReducer,

  isFetchingGetVerificationsByVerificationId: isFetchingGetVerificationsByVerificationIdReducer,
  getVerificationsByVerificationIdError: getVerificationsByVerificationIdErrorReducer,

  postVerificationsSdCreateCaseworkerTask: postVerificationsSdCreateCaseworkerTaskReducer,

  isFetchingPostVerificationsSdCreateCaseworkerTask:
    isFetchingPostVerificationsSdCreateCaseworkerTaskReducer,
  postVerificationsSdCreateCaseworkerTaskError: postVerificationsSdCreateCaseworkerTaskErrorReducer,
});

export default { reducers };
